module.exports = __webpack_public_path__ + "static/media/producto2.26dcf300.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/producto2.png
// module id = 252
// module chunks = 0